import api from "../../services/productItem";
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types("product_item");
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({}, "Product Item");
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations,
	};
}
